import styled from 'styled-components'
import { colors } from 'client/styles'

export const BoardCodeBase = styled.div`
  display: flex;
  align-items: center;

  p {
    color: ${props => colors[props.color]};
    &::first-letter {
      text-transform: uppercase;
    }
  }

  svg {
    fill: ${props => colors[props.color]};
    margin-inline-end: 8px;
    flex: none;
  }
`
